import { render, staticRenderFns } from "./ShowMedicalAdvice.vue?vue&type=template&id=080e398e&scoped=true"
import script from "./ShowMedicalAdvice.vue?vue&type=script&lang=js"
export * from "./ShowMedicalAdvice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080e398e",
  null
  
)

export default component.exports